import React from "react";
import { FaQuoteRight } from "react-icons/fa";
import { BsFillChatQuoteFill } from "react-icons/bs";

export const ReviewArticle = ({ peoples, index }) => {
  return (
    <>
      {peoples.map((person, personIndex) => {
        const { id, name, title, quote, image } = person;
        //Setting the class for style the slider
        let positionClass = "nextSlide";
        if (personIndex === index) {
          positionClass = "activeSlide";
        }
        if (
          personIndex === index - 1 ||
          (index === 0 && personIndex === peoples.length - 1)
        ) {
          positionClass = "prevSlide";
        }
        return (
          <article key={id} className={`article ${positionClass}`}>
            <div className="img-slide-box">
              <img src={image} alt={name} className="reviewImage" />
              <p>
                <BsFillChatQuoteFill />
              </p>
            </div>
            <p className="des">{quote}</p>
            <h4 className="slide-h4"><a href="#">{name}</a></h4>
            <h5 className="slide-h5">{title}</h5>
            <h2 className="h2-quo">
              <FaQuoteRight />
            </h2>
          </article>
        );
      })}
    </>
  );
};
